import { Psychology, Diamond, Webhook, SupportAgent } from '@mui/icons-material';

export const processData = [
    {
        id: 1,
        icon: <Psychology className="processIcon" />,
        service: "Strategy creation",
        desc: "As a leading web developer in Nagpur, we develop a clear and precise understanding of your business that helps us to define your competition and the targeted area of the market your business has to deal with. By finding the latest online trends related to your business, we outline a strategy that ensures positive outcomes."
    },
    {
        id: 2,
        icon: <Diamond className="processIcon" />,
        service: "Design",
        desc: "Transforming websites into masterpieces is what made us the best web design company in Nagpur. As a professionals we're always think out of the box to create websites that catch the attention of internet surfers at one glance. We're incorporates the best layout, color scheme, and style that adds life to your brand."
    },
    {
        id: 3,
        icon: <Webhook className="processIcon" />,
        service: "Development",
        desc: "The reason we are called the best web development company in Nagpur is the experience we hold to provide reliable web development services. We turn your innovative ideas into digital realities. We make your website excellently functional on the online platform to boost engagement, and thereby the conversion rate."
    },
    {
        id: 4,
        icon: <SupportAgent className="processIcon" />,
        service: "Support",
        desc: "Our Development Support will always have your back. Even after your site goes live, we take constant care of its timely maintenance and updating of the latest information so that you never miss an opportunity to stay way ahead of your competitors. With us, you can begin your journey towards success and achieve all milestones along the way."
    },
];

export default processData